export default __webpack_public_path__ + "static/media/about-page.f475f68b.jpg";